import React from "react";
import "./LearnMoreSectionTwo.css";
import DisclaimerText from "./DisclaimerText";
import { IMAGE_URL, SITE_ID } from "../../../services/apiConstants";

export default function LearnMoreSectionTwo(props) {
  return (
    <>
      <div className="broadInvestmentMaincontainer">
        <p className="broadInvestmenttitleTxt">{props?.title}</p>
        <p className="aboveBMW">
          In search of companies with meaningful earnings growth and sustainable
          competitive advantage
        </p>
        <div className="broadInvestmentboxContainer">
          {props.data &&(
          <img
            src={IMAGE_URL + props.data + SITE_ID}
            className="imgBmb"
            alt="bmb-framework"
          />
          )}
          <p className="belowBMW">
            The aforesaid factors/framework are only indicative. There may be
            other factors that may be relevant for identification/selection of
            stock depending upon the varied market conditions
          </p>
        </div>
        <DisclaimerText text={props?.disclaimer} />
      </div>
    </>
  );
}
